import { fetchRequest } from '@common/helpers/util/requestMiddleware';
import _ from 'lodash';

const token = 'C5e3Kc5d8vxVQT7TGBmPf4149R5tHk8r';
const makePaidTicketRequest = _.partial(fetchRequest, 'https://retail-update-board.bcapps.org/api/PaidTicketInfo');

class PaidTicketApi {
  static getList = (requestData) => (
    makePaidTicketRequest('GetPaidTickets', 'POST', { body: { ...requestData, token } })
  );

  static markAsPaid = (requestData) => (
    makePaidTicketRequest('MarkTicketAsPaid', 'POST', { body: { ...requestData, token } })
  );
}

export default PaidTicketApi;
